<template>
  <v-card flat>
    <!--<v-card-title class="headline">Single Sign-On (SSO)</v-card-title>-->
    <v-card-text>
      <v-switch v-model="form.sso_enabled" label="Enable SSO for this organization" class="mb-4" />

      <v-row>
        <v-col cols="12" md="6">
                  <m-edit-select-enum
            label="SSO Provider"
            v-model="form.provider"
            enum_name="sso_provider"
            dialog_title="Select SSO Provider"
            :allow_any_enum_value="false"
        />
        </v-col>
        <v-col cols="12" md="6">
          <m-edit-select label="RedChirp SSO Settings" :possible_values="rc_sso_settings_choices"
            v-model="form.red_chirp_sso_settings_id" :read_only="false" dialog_title="Select RedChirp SSO Settings"
            :value="getSSOSettingsValue(form.red_chirp_sso_settings_id)" v-on:input="setSSOSettingsValue($event)" />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <v-text-field v-model="form.session_version"
            label="Session Version (increase to invalidate non-staff sessions)" type="number" dense />
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field v-model="form.connection" label="Connection (optional)" dense />
        </v-col>
      </v-row>

      <!--
      Not needed for now
      <v-row>
        <v-col cols="12" md="6">
          <v-text-field v-model="form.post_login_redirect" label="Post Login Redirect (optional)" dense />
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field v-model="form.post_logout_redirect" label="Post Logout Redirect (optional)" dense />
        </v-col>
      </v-row>
      -->
      <v-alert type="info" dense text class="mt-2">
        Both increasing session version and enabling or disabling SSO will sign out non-staff users from this organization.
        System admins are not affected. All users associated with this organization will need to use SSO to log in if enabled.
      </v-alert>

      <div class="d-flex mt-4" style="gap: 8px; justify-content: space-between; align-items: center;">
        <v-btn text color="primary" @click="goToAdmin">Manage RedChirp SSO Settings</v-btn>
        <v-spacer />
        <v-btn color="primary" @click="confirm_and_save" :loading="saving">Save Settings</v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'm-settings-organization-sso',
  props: {
    organization_id: { type: String, required: true }
  },
  data() {
    return {
      form: {
        organization_id: this.organization_id,
        sso_enabled: false,
        provider: 'auth0',
        red_chirp_sso_settings_id: null,
        connection: '',
        post_login_redirect: '',
        post_logout_redirect: '',
        session_version: 1
      },
      rc_sso_settings_choices: [],
      saving: false,
      providers: [
        { text: 'Auth0', value: 'auth0' }
      ]
    }
  },
  mounted() {
    this.fetch();
    this.fetchCentral();
  },

  methods: {

    fetch() {
      const org_id = this.form.organization_id;
      this.$rc.rest({
        endpoint: `GET: /api/v1/organizations/sso-settings/${org_id}`,
        spinner: false,
        on_success: (data) => {
          this.form.sso_enabled = !!data.sso_enabled;
          this.form.provider = (data.provider && data.provider.name) ? data.provider.name : (data.provider || 'AUTH0');
          this.form.red_chirp_sso_settings_id = data.red_chirp_sso_settings_id || null;
          this.form.connection = data.connection || '';
          this.form.post_login_redirect = data.post_login_redirect || '';
          this.form.post_logout_redirect = data.post_logout_redirect || '';
          this.form.session_version = data.session_version || 1;
        },
        on_error: 'Unable to load SSO settings'
      });
    },
    save() {
      this.saving = true;
      const payload = { ...this.form };
      this.$rc.rest({
        endpoint: 'PUT: /api/v1/organizations/sso-settings',
        params: payload,
        spinner: true,
        on_success: () => {
          this.$rc.snackbar('SSO settings saved');
          this.fetch();
          this.saving = false;
        },
        on_error: () => {
          this.saving = false;
          this.$rc.alert('Error', 'Unable to save SSO settings');
        }
      });
    },
    getSSOSettingsValue(type) {
      if ( !type ) return null;

      for(let i = 0; i < this.rc_sso_settings_choices.length; i++) {
        if (this.rc_sso_settings_choices[i].value == type) {
          return this.rc_sso_settings_choices[i];
        }
      }
    },
    setSSOSettingsValue(event, index) {
      //console.log(event)
      for(let i = 0; i < this.rc_sso_settings_choices.length; i++) {
        if (this.rc_sso_settings_choices[i].value == event.value) {
          this.form.red_chirp_sso_settings_id = this.rc_sso_settings_choices[i].value;
          return;
        }
      }
    },
    fetchCentral() {
      this.$rc.rest({
        endpoint: 'LIST: /api/v1/admin/auth/red-chirp-sso-settings',
        params: {},
        spinner: false,
        on_success: (data) => {
          const items = (data.results || []).filter(x => !x.archived);
          this.rc_sso_settings_choices = items.map(x => ({
            text: x.label,
            value: x.id
          }));
        },
        on_error: () => {
          this.$rc.alert('Error', 'Unable to load central SSO settings');
        }
      });
    },
    confirm_and_save() {
      // Require explicit confirmation before proceeding
      this.$rc.confirm({
          title: 'Final Confirmation Required',
          body: 'This action may sign out non-staff users from this organization. Do you want to continue?',
          btn_text_ok: 'Execute!!!',
          btn_text_cancel: 'Cancel',
          text_to_confirm: 'Confirm',
          text_to_confirm_message: 'To proceed, please type "Confirm" in the box below:',
          on_ok: () => {
              this.save(); 
          }
      });


    },
    goToAdmin() {
      this.$router.push({ name: 'admin-red-chirp-sso-settings' });
    }
  }
}
</script>

<style scoped>
.bold_header {
  font-weight: 600;
}
</style>
